import { Button, Card, Tooltip, majorScale } from 'evergreen-ui';
import { ChildProps, SaveStatus } from './save-member-group-query.component';
import { FiRotateCcw, FiSave, FiUserPlus, FiX } from 'react-icons/fi';
import React, { FC } from 'react';

import { Action } from '../controllers/edit-member-group.controller';

const SaveTooltip: FC<{ saveStatus: SaveStatus }> = ({ saveStatus, children }) => {
  let content: React.ReactNode | undefined;

  if (saveStatus === 'noSave:invalid') content = 'Please correct the below records before saving';
  else if (saveStatus === 'noSave:pristine') content = 'No changes have been made to save';
  else if (saveStatus === 'canSave:hasWarning') content = 'This record may be incorrect';

  return (
    <Tooltip isShown={content ? undefined : false} content={content}>
      <span>{children}</span>
    </Tooltip>
  );
};

export interface MemberGroupActionsComponentProps extends ChildProps {
  canRevert?: boolean;
  canCancel?: boolean;
  canAddSpouse?: boolean;
  canAddChild?: boolean;
  dispatch: React.Dispatch<Action | { type: 'cancel' }>;
}

export const MemberGroupActionsComponent: FC<MemberGroupActionsComponentProps> = ({
  saveStatus,
  canRevert,
  canCancel,
  canAddSpouse,
  canAddChild,
  dispatch,
  onSave,
}) => (
  <Card
    display="flex"
    flexDirection="row"
    flexWrap="wrap"
    gap={8}
    elevation={2}
    background="white"
    border
    position="sticky"
    top={0}
    zIndex={10}
    paddingX={majorScale(2)}
    paddingY={majorScale(1)}
    flex="100%"
  >
    <SaveTooltip saveStatus={saveStatus}>
      <Button
        iconBefore={saveStatus !== 'saving' ? <FiSave /> : null}
        appearance="primary"
        onClick={onSave}
        disabled={!saveStatus.startsWith('canSave')}
        isLoading={saveStatus === 'saving'}
      >
        Save
      </Button>
    </SaveTooltip>
    {canRevert ? (
      <Button iconBefore={<FiRotateCcw />} appearance="text" onClick={() => dispatch({ type: 'revert' })}>
        Revert
      </Button>
    ) : null}
    {canCancel ? (
      <Button iconBefore={<FiX />} appearance="text" onClick={() => dispatch({ type: 'cancel' })}>
        Cancel
      </Button>
    ) : null}
    {canAddSpouse ? (
      <Button iconBefore={<FiUserPlus />} onClick={() => dispatch({ type: 'addSpouse' })}>
        Add Spouse
      </Button>
    ) : null}
    {canAddChild ? (
      <Button iconBefore={<FiUserPlus />} onClick={() => dispatch({ type: 'addChild' })}>
        Add Child
      </Button>
    ) : null}
  </Card>
);
